export default __webpack_public_path__ + "static/logo-d729c82ea8a756aa39d6d37def56d126.svg";